import React, {Component} from 'react';
// eslint-disable-next-line
import PropTypes from 'prop-types';

import swal from 'sweetalert2';
import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import {SkyLightStateless} from 'react-skylight';

import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import { Spinner } from '../../../../components/Loading/Spinner';
import ToggleInput from '../../../../components/ToggleInput/toggleInput';


class TripCancelModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            trip: props.trip,
            detour: props.trip.status.id === 'B0',

            showModal: false,
            terminals: null,
            // Cancellation
            terminal: '',
            st_number: '',
            cancellation_observations: '',
            inform_cancellation: null,

            form_warning: false,
            ajaxInProgress: false
        }
    }

    componentDidMount() {
        if(this.state.detour) this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeSelects('body');
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
    };

    _fetchOptions = () => {
        const TERMINALS_URL = `${urls.API_ROOT}/api/v1/terminal/`;
        axios.get(TERMINALS_URL, tokenHeader())
            .then((response) => {
                this.setState({
                    terminals: response.data
                }, this._initializeHtml);
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _closeModal = () => {
        this.setState({showModal: false});
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _submitCancellation = () => {

        let {terminal, st_number, cancellation_observations, inform_cancellation, detour, trip} = this.state;

        if((detour && (terminal === '' || st_number === '')) || (!detour && inform_cancellation === null) || cancellation_observations === ''){
            this.setState({form_warning: true});
            return false;
        }

        this.setState({ajaxInProgress: true, form_warning: false});

        let data = {
            next_status: detour ? 'E103' : 'E104',
            cancellation_observations
        };

        if(detour){
            data['terminal'] = terminal;
            data['st_number'] = st_number;
        }else{
            data['inform_cancellation'] = inform_cancellation;
        }

        const TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${trip.id}/`;
        axios.put(`${TRIP_URL}`, data, tokenHeader())
            .then(response => {
                this.setState({
                    showModal: false,
                    ajaxInProgress: false
                }, () => this._onRejectSuccess(response));
            })
            .catch(this._onSubmitError);
    };

    _onRejectSuccess = (response) => {
        if(this.state.detour){
            swal({
                title: 'Viaje cancelado',
                html: 'El viaje ha sido desviado correctamente. Espere unos segundos mientras lo redirigimos al nuevo viaje',
                type: 'success',
                showConfirmButton: false,
                timer: 3000
            });
            setTimeout(() => {
                this.props.history.push(`/trips/${response.data.id}`);
            }, 3000);
        }else{
            swal({
                title: 'Viaje cancelado',
                html: 'El viaje ha sido cancelado correctamente. Espere unos segundos por favor',
                type: 'success',
                showConfirmButton: false,
                timer: 3000
            });
            setTimeout(this.props.reloadTrip, 3000);
        }
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido rechazar el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };


    render() {
        let modalStyle = {
            boxShadow: 'none'
        };

        let body = (
            <div>
                <div className={"col s12"}>
                    <p>Usted esta por cancelar el viaje de número ST <b>{this.state.trip.st_number}</b>. Esta acción no puede deshacerse.</p>
                    <p>Si desea continuar, por favor complete el formulario debajo.</p>
                </div>
                <div className={"col s12"}>
                    <ToggleInput
                        selected={this.state.inform_cancellation}
                        name={'¿Desea informar la cancelación al sistema interno de Shell?'} stateVar={'inform_cancellation'}
                        toggleAction={this._handleToggle}
                    />
                </div>
                <div className={`col s12 input-field margin-top-20`}>
                    <label className="active">Observaciones</label>
                    <textarea
                        className={"materialize-textarea dispatch-textarea"} rows={4}
                        onChange={(ev) => this._handleInput('cancellation_observations', ev.target.value)}
                        defaultValue={this.state.cancellation_observations}
                    />
                </div>

                {this.state.form_warning &&
                    <div className={'shell-red-text'}>Por favor, complete todos los campos del formulario.</div>
                }
            </div>
        );

        if(this.state.detour){
            body = (
                <div>
                    <div className={"col s12"}>
                        <p>Usted esta por cancelar el viaje <b>{this.state.trip.st_number}</b> y enviarlo a una nueva terminal. Esta acción no puede deshacerse.</p>
                        <p>Si desea continuar, por favor complete el formulario debajo.</p>
                    </div>
                    <div className={"col s6"}>
                        <div className={`input-field ${this.state.warn_reason ? 'error-input' : ''}`} >
                            <label className="active">Nueva terminal</label>
                            <select defaultValue={this.state.terminal}
                                    data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Seleccione la nueva terminal</option>
                                {this.state.terminals && this.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className={"col s6 input-field input-grey"}>
                        <label className="active">Número ST</label>
                        <input placeholder={"Ingrese el nuevo número ST"} value={this.state.st_number}
                               onChange={(ev) => this._handleInput('st_number', ev.target.value)}
                        />
                    </div>
                    <div className={`col s12 input-field margin-top-20`}>
                        <label className="active">Observaciones</label>
                        <textarea
                            className={"materialize-textarea dispatch-textarea"} rows={4}
                            onChange={(ev) => this._handleInput('cancellation_observations', ev.target.value)}
                            defaultValue={this.state.cancellation_observations}
                        />
                    </div>

                    {this.state.form_warning &&
                    <div className={'shell-red-text'}>Por favor, complete todos los campos del formulario.</div>
                    }
                </div>
            );
        }

        let buttonsDisabled = this.state.ajaxInProgress;

        return (
            <div className={"text-right"}>
                <button className={'btn btn-shell-empty z-depth-0'}
                        onClick={() => this.setState({showModal: true})}>
                    Cancelar viaje
                </button>
                <SkyLightStateless
                    onOverlayClicked={this._closeModal}
                    isVisible={this.state.showModal}
                    onCloseClicked={this._closeModal}
                    dialogStyles={modalStyle}
                    title={<h3 className="center" style={{fontSize: '30px'}}>Cancelación de viaje</h3>}
                >
                    <div className={"row margin-top-20 text-left"}>
                        {body}
                        <div className={"col s12 center margin-top-30"}>
                            <button className={`btn btn-shell-empty z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`}
                                    onClick={this._closeModal}>
                                Cancelar
                            </button>
                            <button className={`btn btn-shell z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`}
                                    onClick={this._submitCancellation}>
                                Cancelar viaje
                            </button>
                        </div>
                    </div>
                    {this.state.ajaxInProgress ? <Spinner /> : <div><br/><br/></div>}
                </SkyLightStateless>
            </div>
        );
    }
}


TripCancelModal.propTypes = {
};

TripCancelModal.defaultProps = {
    message: 'Usted está por rechazar el viaje. Para continuar, complete el formulario debajo'
};

export default withRouter(TripCancelModal);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripCancelModal.js